import Component from '../abstracts/Component';

export default class GiftcardFormComponent extends Component {

  get SELECTORS() {
    return {
        main: '.form-giftcard',
        radioValuesRow: '.jsRadioValues',
        numberValueInput: '.jsNumberValue',
        giftcard: '.js-addtocart-giftcard',
    };
  }

  constructor() {
    super();
  }
  uncheckInputs(inputs){
    for (let input of inputs){
      input.checked= false;
      input.required=false;
      console.log(input.checked);
    }
  }
  setRequiredInputs(inputs){
    for(let input of inputs){
      input.required = true;
    }
  }
  isSettedRadioValue(inputs){
    for(let input of inputs){
      if(input.checked){
        return true;
      }
    }
  }
  handleGiftcardValue() {
      let valuesRow = document.querySelector(this.SELECTORS.radioValuesRow);
      let checkedRadioInputs = valuesRow.querySelectorAll('input');
      let numberValueInput   = document.querySelector(this.SELECTORS.numberValueInput);


      numberValueInput.addEventListener('focus', () => {
          this.uncheckInputs(checkedRadioInputs);
          numberValueInput.required=true;
      });
      for(let input of checkedRadioInputs){
          input.addEventListener('change',()=>{
            numberValueInput.required = false;
            numberValueInput.value = '';
          });
      }

  }
  initFormHandler(){
    this.handleGiftcardValue();
    this.bindCustomEvents();
  }
  render() {
    this.log('Rendering...');
    if(document.querySelector(this.SELECTORS.main)){
      this.initFormHandler();
    }

    this.checkGcTerms(this);

    let _this = this;
    $("body").on("change", "[name='gcTerms']", function () {
      _this.checkGcTerms(_this);
    });
  }

  checkGcTerms(_this) {
    if ($("[name='gcTerms']").is(":checked")) {
      $(_this.SELECTORS.giftcard).attr('disabled', false);
      $(_this.SELECTORS.giftcard).removeClass("disabled");
    } else {
      $(_this.SELECTORS.giftcard).attr('disabled', true);
      $(_this.SELECTORS.giftcard).addClass("disabled");
    }
  }

  bindCustomEvents() {
    this.preventScrollEventOnFreeAmountInput();
  }

  preventScrollEventOnFreeAmountInput(){
    $(this.SELECTORS.numberValueInput).on('mousewheel', function (e) {
      e.preventDefault();
    })
  }

}
